import React from 'react'
import { Text, View, Font } from '@react-pdf/renderer'

Font.register({
  family: 'Inter',
  fonts: [
    { src: `${process.env.PUBLIC_URL}/font/Inter-Regular.ttf` },
    { src: `${process.env.PUBLIC_URL}/font/Inter-Medium.ttf`, fontWeight: 500 },
    { src: `${process.env.PUBLIC_URL}/font/Inter-SemiBold.ttf`, fontWeight: 600 }
  ]
})

const FooterDynamic = ({ uiData }) => {
  return (
    <View fixed
      style={{
        textAlign: 'center',
        paddingBottom: 20,
        marginTop: 'auto',
      }}
    >
      <Text style={{
        fontSize: 8,
        fontWeight: 500,
        fontFamily: 'Inter',
      }}
        render={({ pageNumber, totalPages }) => (
          `${uiData.page} ${pageNumber} ${uiData.from} ${totalPages}`
        )} />
    </View>
  )
}

export default FooterDynamic